import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=5f45d0dc"
import script from "./PurchaseInfo.vue?vue&type=script&lang=ts"
export * from "./PurchaseInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f45d0dc')) {
      api.createRecord('5f45d0dc', component.options)
    } else {
      api.reload('5f45d0dc', component.options)
    }
    module.hot.accept("./PurchaseInfo.vue?vue&type=template&id=5f45d0dc", function () {
      api.rerender('5f45d0dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/purchases/PurchaseInfo.vue"
export default component.exports